import ABCyaLib from '@abcya/abcya_lib';
import gameData from '../../gameData'
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../../FontKeys';

export function doPrint(game, callback) {
    const { canPrintImages } = ABCyaLib.Environment.instance.capabilities
    // Print and rotate portion of screen
    game.renderer.snapshotArea(0, 0, game.canvas.width, game.canvas.height, async (image) => {
        // Mobile doesn't currently print, so it routes print requests to camera roll saves. 
        // In this case we don't want to rotate the image.
        if (canPrintImages) {
            image = await ABCyaLib.Bitmap.rotateHTMLImage(image);
        }
        try {
            await ABCyaLib.PrintSave.instance.printImage(image)
        }
        catch (error) {
            console.error(error);
        }
        callback()
    })
}

export function doSave(game, callback) {
    game.renderer.snapshot(async (image) => {
        try {
            await ABCyaLib.PrintSave.instance.saveImage(image, { fileName: gameData.maskLocalization.getLocalizedString("miscInfo.fileName", gameData.maskLocalization.isDefault) });
        }
        catch (error) {
            console.error(error);
        }
        callback()
    })
}

export function createPrintAssets(scene, isPrint, callback) {
    let rect = new Phaser.Geom.Rectangle(0, 0, scene.mid.x * 2, scene.mid.y * 2);
    let shader = scene.add.graphics({ fillStyle: { color: 0xFFFFFF } });
    shader.fillRectShape(rect);
    shader.setDepth(1);
    shader.alpha = 0;

    const header = scene.addImage(scene.mid.x, 60, "Name").setDepth(100).setScale(0);
    const footer = scene.addImage(scene.mid.x, scene.mid.y * 2 - 60, "Created_ABCya").setDepth(100).setScale(0);
    const htxt = ABCyaPhaser.Text.addText(scene.mid.x - 115, 60, 18, 0x393630, FontKeys.din_alternatebold, gameData.maskLocalization.getLocalizedString("miscInfo.name", gameData.maskLocalization.isDefault), scene, false).setAlign("right").setOrigin(1, .5).setDepth(100).setScale(0);
    const ftxt = ABCyaPhaser.Text.addText(scene.mid.x - 20, scene.mid.y * 2 - 60, 18, 0x393630, FontKeys.din_alternatebold, gameData.maskLocalization.getLocalizedString("miscInfo.created", gameData.maskLocalization.isDefault), scene, false).setAlign("right").setOrigin(1, .5).setDepth(100).setScale(0);

    scene.addTween(shader, 300, { alpha: 1 }, Phaser.Math.Easing.None);
    scene.addTween(header, 500, { scale: 1 }, Phaser.Math.Easing.Back.Out);
    scene.addTween(htxt, 500, { scale: 1 }, Phaser.Math.Easing.Back.Out);
    scene.addTween(ftxt, 500, { scale: 1 }, Phaser.Math.Easing.Back.Out);
    scene.addTween(footer, 500, { scale: 1 }, Phaser.Math.Easing.Back.Out,
        () => {
            if (isPrint) {
                doPrint(scene.game, () => {
                    callback();

                    scene.addTween(header, 500, { scale: 0 }, Phaser.Math.Easing.Back.Out, () => { header.destroy(); });
                    scene.addTween(footer, 500, { scale: 0 }, Phaser.Math.Easing.Back.Out, () => { footer.destroy(); });
                    scene.addTween(htxt, 500, { scale: 0 }, Phaser.Math.Easing.Back.Out, () => { htxt.destroy(); });
                    scene.addTween(ftxt, 500, { scale: 0 }, Phaser.Math.Easing.Back.Out, () => { ftxt.destroy(); });
                    scene.addTween(shader, 500, { alpha: 0 }, Phaser.Math.Easing.None, () => { shader.destroy(); });
                });
            } else {
                doSave(scene.game, () => {
                    callback();

                    scene.addTween(header, 500, { scale: 0 }, Phaser.Math.Easing.Back.Out, () => { header.destroy(); });
                    scene.addTween(footer, 500, { scale: 0 }, Phaser.Math.Easing.Back.Out, () => { footer.destroy(); });
                    scene.addTween(htxt, 500, { scale: 0 }, Phaser.Math.Easing.Back.Out, () => { htxt.destroy(); });
                    scene.addTween(ftxt, 500, { scale: 0 }, Phaser.Math.Easing.Back.Out, () => { ftxt.destroy(); });
                    scene.addTween(shader, 500, { alpha: 0 }, Phaser.Math.Easing.None, () => { shader.destroy(); });
                });
            }
        }
    );
}